import React, { useState } from "react";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Select } from "../../../components/form";
import { SendIcon } from "../../../components/icons";
import { UserRole, TaskStatus, TaskPriority } from "../../../__generated__/globalTypes";
import { taskPriorityLabel, taskStatusLabel } from "../../../helpers/enum-labels";
import { useMe } from "../../users/hooks/useMe";
import { useTasks } from "../hooks";
import { TaskItem } from "../components";

export const Tasks: React.FC = () => {
  const { data: meData } = useMe();
  const isAdmin = meData?.me?.role === UserRole.Admin;

  const [scope, setScope] = useState<"mine" | "all">("mine");
  const [status, setStatus] = useState<string>("");
  const [priority, setPriority] = useState<string>("");

  const where: any = {};
  if (isAdmin && scope === "mine") where.userId = meData?.me?.id;
  if (status) where.status = status;
  if (priority) where.priority = priority;

  const { data, loading, refetch } = useTasks({ where });

  return (
    <>
      <Header
        title="Tâches"
        subtitle={isAdmin && scope === "all" ? "Toutes les tâches" : "Mes tâches"}
        buttons={[
          {
            actionText: "Nouvelle tâche",
            bgColor: "indigo",
            textColor: "white",
            link: `/task/create`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <div className="card mb-4 flex flex-wrap gap-3 items-end">
          {isAdmin && (
            <Select
              label="Vue"
              className="w-48"
              value={scope}
              onChange={(e) => setScope(e.target.value as "mine" | "all")}
            >
              <option value="mine">Mes tâches</option>
              <option value="all">Toutes les tâches</option>
            </Select>
          )}
          <Select
            label="Statut"
            className="w-48"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="">Tous</option>
            {Object.keys(TaskStatus).map((s) => (
              <option key={s} value={s}>
                {taskStatusLabel(s)}
              </option>
            ))}
          </Select>
          <Select
            label="Priorité"
            className="w-48"
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
          >
            <option value="">Toutes</option>
            {Object.keys(TaskPriority).map((p) => (
              <option key={p} value={p}>
                {taskPriorityLabel(p)}
              </option>
            ))}
          </Select>
        </div>

        <div className="p-4 mb-6 bg-white shadow rounded">
          {loading ? (
            <Loading />
          ) : !data?.tasks?.results?.length ? (
            <EmptyList text="Aucune tâche" />
          ) : (
            <div>
              {data?.tasks?.results?.map((task) => (
                <TaskItem
                  key={`task-${task.id}`}
                  task={task}
                  showOwner={isAdmin && scope === "all"}
                  onChanged={refetch}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
